// extracted by mini-css-extract-plugin
export default {"MilestoneTemplates":"MilestoneTemplates_MilestoneTemplates__g7loJ","Templates":"MilestoneTemplates_Templates__lLcGm","NoTaskTemplate":"MilestoneTemplates_NoTaskTemplate__RmALi"};